/**
 * @generated SignedSource<<47cf33694432f7b8974222329ce40ab3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ViewerSawBeaconInput = {
  beacon: string;
  clientMutationId?: string | null;
};
export type beaconsSawBeaconMutation$variables = {
  input: ViewerSawBeaconInput;
};
export type beaconsSawBeaconMutation$data = {
  readonly viewerSawBeacon: {
    readonly viewer: {
      readonly unreadBeacons: ReadonlyArray<string>;
    };
  } | null;
};
export type beaconsSawBeaconMutation = {
  response: beaconsSawBeaconMutation$data;
  variables: beaconsSawBeaconMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unreadBeacons",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "beaconsSawBeaconMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ViewerSawBeaconPayload",
        "kind": "LinkedField",
        "name": "viewerSawBeacon",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "beaconsSawBeaconMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ViewerSawBeaconPayload",
        "kind": "LinkedField",
        "name": "viewerSawBeacon",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21b48e4fdf4a1ba47bc4011a8d463222",
    "id": null,
    "metadata": {},
    "name": "beaconsSawBeaconMutation",
    "operationKind": "mutation",
    "text": "mutation beaconsSawBeaconMutation(\n  $input: ViewerSawBeaconInput!\n) {\n  viewerSawBeacon(input: $input) {\n    viewer {\n      unreadBeacons\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f2855014bac4ba17ce1b361fb92ce71a";

export default node;
